module.exports = __webpack_public_path__ + "static/media/Anwar Sadath - Project Manager.2fff7e95.jpg";